import { Button } from '@material-ui/core';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const StyledQandA = styled.div`
  dl dt {
    background-color: #231815;
    color: #fff;
    padding: 10px;
    font-size: 1.2rem;
    line-height: 1.5rem;
    font-weight: bold;
  }

  dl dt h3::before {
    content: 'Q.';
    font-size: 1.2rem;
    font-weight: bold;
  }

  dl dd {
    padding: 10px;
  }

  .linkIndex {
    text-align: center;
    margin: 20px auto 0px auto;
  }
`;

/**
 * 購入をお考えの方へページ
 */
const QandA: FC = () => {
  return (
    <StyledQandA>
      <h2>購入をお考えの方へ</h2>
      <dl>
        <dt>
          <h3>認証アカウントを持っていない</h3>
        </dt>
        <dd>
          認証アカウントをお持ちでない方は、別途Facebook・Google・LINE・Twitterいずれかのアカウントの作成が必要です。
          <br />
          Googleアカウントを作成する場合は
          <a
            href="https://support.google.com/accounts/answer/27441?hl=ja"
            target="_blank"
            rel="noreferrer"
          >
            こちら
          </a>
        </dd>
        <dt>
          <h3>料金の支払い方法は？</h3>
        </dt>
        <dd>
          <p>クレジットカード決済と代金引換（現金）をご利用いただけます。</p>
        </dd>
        <dt>
          <h3>プリペイド決済サービスは使用できる？</h3>
        </dt>
        <dd>
          <p>
            現在以下のサービスに対応しております。
            <br />
            ・Kyash (
            <a href="https://kyash.co" target="_blank" rel="noreferrer">
              https://kyash.co
            </a>
            )<br />
            <br />
            以下の決済サービスには現在対応しておりません。
            <br />
            ・LINE Pay カード
            <br />
            ・おさいふPONTA
            <br />
            ・au Wallet
          </p>
        </dd>
        <dt>
          <h3>発送時梱包について</h3>
        </dt>
        <dd>
          <p>
            原則的に個々の製品の包装はしません。又、
            発送時のダンボールはリユースしたものも有ります。
            <br />
            資源を大切に使い、無駄のないように配慮しています。
          </p>
        </dd>
      </dl>
      <div className="linkIndex">
        <Button variant="contained" color="primary" component={Link} to="/">
          前のページへ戻る
        </Button>
      </div>
    </StyledQandA>
  );
};

export default QandA;
